<template>
  <v-form>
    <v-row>
      <v-col cols="4">
        <v-text-field name="paymentModeName" outlined dense label="Name" v-model="record.Name"></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    record: {},
    tax_type: null,
    rate: null,
    loader: false,
    categories: [
      { name: "Purchase Tax", value: "P" },
      { name: "Sales Tax", value: "S" },
    ],
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
      if (this.record.tax_type == 0) {
        this.tax_type = "P";
      } else {
        this.tax_type = "S";
      }
    },
    sendData() {
      var taxType = this.tax_type == "P" ? 0 : 1;
      this.record.rate = parseFloat(this.record.rate);
      this.record.tax_type = taxType;
      console.log(this.record, " tax record");
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
  },
};
</script>